import Properties from "../../_model/ModelEngineeringProperties"

const EngineeringMapping = {
    setMapping: function(prop = new Properties){
        if(!prop || !prop.index)
            return ''

        if (prop.type == "Correntes" && prop.propName == "Atributos") {
            return `cr|${prop.index}|Atributos|${prop.key}`;
        } 
        else if (prop.type == "Correntes" && prop.propName != "Atributos")
        {
            return `cp|${prop.index}|${prop.propName}|${prop.key}`;
        } 
        else if(prop.type == "CorrenteInterna")
        {
            if (prop.subType == "Atributos")
                return `in|${prop.index}|${prop.component}|Atributos|${prop.key}`
            else 
                return `ci|${prop.index}|${prop.component}|${prop.subType}|${prop.key}`
        }
        else
        {
            if (prop.subType == "Atributos") return `op|${prop.index}|${prop.key}`;
            else if (prop.subType == "Equipamentos")
                return `eq|${prop.index.split("|")[1]}|${prop.equipName}|${prop.key}`;
            else if (prop.subType == "Correntes")
                return `eq|${prop.index}|${prop.equipName}|${prop.key}`;
        }
    },

    unstructureMapping(mapping) {
        let arrayMap = mapping.split("|")
        let stType = arrayMap[0]
        let stCurrent = arrayMap[1]

        if (stType == "cr" || stType == "cp") {
            let stProp = arrayMap[2]
            let stAttr = arrayMap[3]
            return {
                stCurrent,
                stProp,
                stAttr
            }
        } else if (stType == "op") {
            let stProp = arrayMap[2]
            let operation = `${stCurrent}|${stProp}`
            // Aceita formato canônico RTO 5-partes: op|<TipoOp>|<NomeOp>|Atributos|<attr>
            let stAttr = arrayMap.length === 5 ? arrayMap[4] : arrayMap[3]
            return {
                operation,
                stAttr
            }

        } else if (stType == "eq") {
            if(arrayMap.length == 5){
                let stProp = arrayMap[2]
                let equipment = arrayMap[3]
                let operation = `${stCurrent}|${stProp}`
                let stAttr = arrayMap[4]
                return {
                    operation,
                    equipment,
                    stAttr,
                }
            }
            else
            {
                let equipment = arrayMap[2]
                let operation = `${stCurrent}|${equipment}`
                let stAttr = arrayMap[3]
                return {
                    operation,
                    equipment,
                    stAttr,
                }
            }

        } else if (stType == "in") {
            let stProp = arrayMap[2]
            let operation = `${stCurrent}|${stProp}`
            let componentType = arrayMap[3]
            let stAttr = arrayMap[5]
            return {
                operation,
                componentType,
                stAttr
            }
        } else if (stType == "ci") {
            let stProp = arrayMap[2]
            let operation = `${stCurrent}|${stProp}`
            let component = arrayMap[3]
            let componentType = arrayMap[4]
            let stAttr = arrayMap[5]
            return {
                operation,
                component,
                componentType,
                stAttr
            }
        }
    },
}

export default EngineeringMapping